import React from "react";
import { CommunityPricesTable } from "./components/CommunityPricesTable";
import { useCommunityPrices } from "./hooks/useCommunityPrices";

const CommunityPricesPage: React.FC = () => {
  const { rows, search, setSearch, initialLoading, refreshing, toastRef } = useCommunityPrices();
  return (
    <CommunityPricesTable
      rows={rows}
      search={search}
      setSearch={setSearch}
      initialLoading={initialLoading}
      refreshing={refreshing}
      toastRef={toastRef}
    />
  );
};

export default CommunityPricesPage;